<shared-modal-type-dynamic-height [modalData]="modalData" [center]="true" [mobilePreserve]="true" [size]="size"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-reward">

    <shared-vcard-for-wizzard [title]="title$ | async" [description]="(product$ | async)?.ProductDescription || null"
        [loading]="loading$ | async" [imageSrc]="(image$ | async)?.data" class="modal-for-reward__content">
        <shared-text [bigger]="true" [brandAccent]="false" class="modal-for-reward__valid">Valid until
            {{(product$ | async)?.ExpiryDate | date: 'dd/MM/yyyy'}}</shared-text>
    </shared-vcard-for-wizzard>

</shared-modal-type-dynamic-height>